<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Point of Sale</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccured"
    (click)="loadSalonInfo()"
  ></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccured">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>
      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <ion-card class="ion-padding">
          <form [formGroup]="enablePOSForm" *ngIf="salon">
            <ion-item lines="none">
              <ion-label mode="md"
                >I would like to use the point of sale system</ion-label
              >
              <ion-toggle
                formControlName="enablePOSToggle"
                mode="md"
              ></ion-toggle>
            </ion-item>
            <ion-button expand="block" (click)="save()"> Save </ion-button>
          </form>
        </ion-card>

        <ion-list class="ion-margin-top" *ngIf="enablePOSToggle.value">
          <ion-item class="option" routerLink="./taxes">Taxes</ion-item>
          <ion-item class="option" routerLink="./currency">Currency</ion-item>
          <ion-item class="option" routerLink="./payment-types"
            >Accepted payment types</ion-item
          >
          <ion-item class="option" routerLink="./discounts">Discounts</ion-item>
          <!-- <ion-item class="option" disabled>Square POS</ion-item > -->
        </ion-list>
      </ion-col>
      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>
